"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MatrixDependencies = void 0;
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var MatrixDependencies = exports.MatrixDependencies = {
  createMatrixClass: _factoriesAny.createMatrixClass
};